<template>
  <component
    :is="currentComponent"
    :translate-key="props.translateKey"
    :translate-options="props.translateOptions"
  />
</template>

<script setup>
import TranslateEdit from "~/shared/components/i18n/Translate/TranslateEdit.vue";
import TranslateSimple from "~/shared/components/i18n/Translate/TranslateSimple.vue";
import { useCurrentUserStore } from "~/stores/userStore";

const props = defineProps({
  translateKey: {
    type: String,
    required: true,
  },
  translateOptions: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  noedit: {
    type: Boolean,
    default: false,
  },
});

const currentUserStore = useCurrentUserStore();
// Avoid hydration mismatch: TranslateEdit uses ClientOnly, so only switch to it
// after mount. Server and initial client render always use TranslateSimple.
const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
});

const currentComponent = computed(() => {
  if (isMounted.value && !props.noedit && currentUserStore.isAdmin) {
    return TranslateEdit;
  }
  return TranslateSimple;
});
</script>
